module.exports = __webpack_public_path__ + "static/media/hn.9b9bee13.svg";